import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, CompanyDataService, CompanyData, QueryParameter, ModelData, ModalSize, ModalService, DefgIniService, YtKontrolaJmbg, KJSData, KJSDataService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
//import { Komitent } from './komitent';
//import { NotifierService } from 'angular-notifier';
// import { NotificationsService } from 'angular2-notifications';
import { Komitent } from './komitent';
import { Validators, FormControl, FormGroup, ValidatorFn } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { TipKomitenta } from '../tip-komitenta/tip-komitenta';
import { Mesto } from '../mesto/mesto';
import { KomitentUvozNBS } from './komitent-uvoz-nbs/komitent-uvoz-nbs';
import { KomitentUvozNbsComponent } from './komitent-uvoz-nbs/komitent-uvoz-nbs.component';
import { KomitentEmail } from './komitent-email/komitent-email';
import { KomitentZrc } from './komitent-zrc/komitent-zrc';
import { KomitentTelefon } from './komitent-telefon/komitent-telefon';
import { Banka } from '../banka/banka';
import { Svojina } from '../svojina/svojina';
import { VrstaTelefona } from '../vrsta-telefona/vrsta-telefona';
import { Drzava } from '../drzava/drzava';
import { Company } from 'src/app/admin/company/company';
import { Input } from '@angular/core';
import { KomitentView } from './komitent-view';
// import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'yt-komitent-update',
  templateUrl: './komitent-update.component.html'
})


export class KomitentUpdateComponent extends BaseUpdateComponent<Komitent> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected companyDataService : CompanyDataService,
    protected modalService: ModalService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected kjsDataService: KJSDataService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService, modalService);
  }

  checkPib:boolean = false;
  checkMaticniBroj:boolean = false;
  loadingCompanyData:boolean = false;
  loadingCompanyDataByPib:boolean = false;
  loadingCompanyDataByMB:boolean = false;
  loadingJbkjsDataByPib: boolean = false;

  @ViewChild('tabSet', { static: true }) tabset: any;
  @ViewChild("detailList", { static: false }) detailList;
  mestoNaziv: string = "";
  komitentUvozNbs : KomitentUvozNBS[];
  unoseSeUpisnaMestaZaKomitente: boolean = false;
  drzavaID: number;
  inoDrzava: boolean = false;
  drzavaNaziv: string = "";
  idKomitenta: number;

  @Input() set SetFirmaKodKupca(value){
    this.baseFormGroup.patchValue({FirmaSifraKodKupca: value.FirmaSifraKodKupca})
    this.baseFormGroup.get('FirmaSifraKodKupca').updateValueAndValidity();
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'KOMITENT.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(200), 'maxlength', 'KOMITENT.NAZIV.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("SNaziv", Validators.required, 'required', 'KOMITENT.SNAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("SNaziv", Validators.maxLength(100), 'maxlength', 'KOMITENT.SNAZIV.VALIDATION.MAXLENGTH');
    // this.addValidatorToFc("Pib", Validators.required, 'required', 'KOMITENT.PIB.VALIDATION.REQUIRED');
    this.addValidatorToFc("Pib", Validators.maxLength(9), 'maxlength', 'KOMITENT.PIB.VALIDATION.MAXLENGTH');
    // this.addValidatorToFc("MaticniBroj", Validators.required, 'required', 'KOMITENT.MATICNIBROJ.VALIDATION.REQUIRED');
    this.addValidatorToFc("MaticniBroj", Validators.maxLength(8), 'maxlength', 'KOMITENT.MATICNIBROJ.VALIDATION.MAXLENGTH');
    //this.addValidatorToFc("VrstaKomitentaID", Validators.required, 'required', 'KOMITENT.VRSTAKOMITENTA.VALIDATION.REQUIRED');
    this.addValidatorToFc("TipKomitentaID", Validators.required, 'required', 'KOMITENT.TIPKOMITENTA.VALIDATION.REQUIRED');
    this.addValidatorToFc("Adresa", Validators.maxLength(200), 'maxlength', 'KOMITENT.ADRESA.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("MestoID", Validators.required, 'required', 'KOMITENT.MESTO.VALIDATION.REQUIRED');
    this.addValidatorToFc("OdgLice", Validators.maxLength(100), 'maxlength', 'KOMITENT.ODGLICE.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Jmbg", Validators.maxLength(13), 'maxlength', 'KOMITENT.JMBG.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Jmbg",YtKontrolaJmbg, 'jmbgControl', 'FW.KONTROLAPOMODULU.VALIDATION.MODUL11');
    this.addValidatorToFc("BrojGazdinstva", Validators.maxLength(30), 'maxlength', 'KOMITENT.BROJGAZDINSTVA.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("BrojPoreskogResenja", Validators.maxLength(30), 'maxlength', 'KOMITENT.BROJPORESKOGRESENJA.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("ImeOca", Validators.maxLength(50), 'maxlength', 'KOMITENT.IMEOCA.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("BrojLicneKarte", Validators.maxLength(9), 'maxlength', 'KOMITENT.BROJLICNEKARTE.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("PdvBroj", Validators.maxLength(15), 'maxlength', 'KOMITENT.PDVBROJ.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Web", Validators.maxLength(50), 'maxlength', 'KOMITENT.WEB.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Napomena", Validators.maxLength(2000), 'maxlength', 'KOMITENT.NAPOMENA.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("Jbkjs", Validators.maxLength(5), 'maxlength', 'KOMITENT.JBKJS.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("InoOpis", Validators.maxLength(500), 'maxlength', 'KOMITENT.INOOPIS.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("InoZip", Validators.maxLength(10), 'maxlength', 'KOMITENT.INOZIP.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("InoMesto", Validators.maxLength(250), 'maxlength', 'KOMITENT.INOMESTO.VALIDATION.MAXLENGTH');
    this.addValidatorToFc("InoPib", Validators.maxLength(10), 'maxlength', 'KOMITENT.INOPIB.VALIDATION.MAXLENGTH');

    this.addValidatorToFc("InoZip", CheckInoZipByDrzavaID('InoZip',this),'required','KOMITENT.ZIP.VALIDATION.REQUIRED')
    this.baseFormGroup.get('InoZip').updateValueAndValidity();

    this.addValidatorToFc("InoMesto", CheckInoMestoByDrzavaID('InoMesto',this),'required','KOMITENT.MESTO.VALIDATION.REQUIRED')
    this.baseFormGroup.get('InoMesto').updateValueAndValidity();

    this.baseFormGroup.setValidators(CheckByTipKomitenta('TipKomitentaID','Pib','MaticniBroj','Jmbg','BrojGazdinstva'));
    this.baseFormGroup.updateValueAndValidity();

    this.IDProcessed
        .subscribe((value) => {
            if (value && this.Item.ID == -1){
                this.baseFormGroup.patchValue({'TipKomitentaID' : 1});
                this.baseFormGroup.get('TipKomitentaID').updateValueAndValidity();
                this.baseFormGroup.get('Jmbg').disable();
                this.baseFormGroup.get('Jmbg').updateValueAndValidity();
                this.baseFormGroup.get('BrojGazdinstva').disable();
                this.baseFormGroup.get('BrojGazdinstva').updateValueAndValidity();
                this.baseDataService.Get('firma','GetCompanyId',null,Company)
                    .subscribe((data:Company[])=>{
                        this.baseFormGroup.patchValue({'DrzavaID' : data["DrzavaID"]});
                        this.baseFormGroup.get('DrzavaID').updateValueAndValidity();
                    });
            }else if(value && this.Item.ID != -1){
                this.detailList.RefreshData();
            }
        });
  }

 ngAfterViewInit(){
    this.IDProcessed
    .subscribe((value) => {
        if (this.Item.ID == -1){
          this.tabset.select('tbList');
       
        }
    });
 }
  GetCompanyDataByPib(){
    if(!this.baseFormGroup.get('Pib').value || this.baseFormGroup.get('Pib').value == '' || this.fc.Pib.invalid){
        this.checkPib = true;
        this.translateService.get(['NBS.PIB.WARNING'])
            .subscribe(translate => {
                // this.notificationsService.alert(translate['NBS.PIB.WARNING']);
                this.toastrService.info(translate['NBS.PIB.WARNING']);
                return;
            });
    }    
    else{
        //alert('Preuzimanje podataka o firmi na osnovu PIB-a');
        this.loadingCompanyData = true;
        this.companyDataService.GetCompanyDataByTaxNo(this.baseFormGroup.get('Pib').value)
        .subscribe((data: CompanyData[]) => {
            this.loadingCompanyData = false;
            if(data.length == 0){
                this.translateService.get(['NBS.PIB.WARNING'])
                  .subscribe(translate => {
                    // this.notificationsService.alert(translate['NBS.PIB.WARNING']);
                    this.toastrService.info(translate['NBS.PIB.WARNING']);
                    return;
                  });
                // alert('Ne postoje podaci za uneti PIB');
                // return;
            }
            else
                this.setCompanyData(data[0]);
        })  
    }  
}

GetCompanyDataByPibNovo(value){
    if(!this.baseFormGroup.get('Pib').value || this.baseFormGroup.get('Pib').value == '' || this.fc.Pib.invalid){
        this.checkPib = true;
        this.translateService.get(['NBS.PIB.WARNING'])
            .subscribe(translate => {
                // this.notificationsService.alert(translate['NBS.PIB.WARNING']);
                this.toastrService.info(translate['NBS.PIB.WARNING']);
                return;
            });
    }    
    else{
        this.baseDataService.Get("komitent","getIDfromUslov",[new QueryParameter('uslov', "pib = '" + this.baseFormGroup.get('Pib').value + "'")],Komitent)
        .subscribe((result) =>{
            if (Number(result) > 0){
                this.translateService.get(['NBS.PIB.EXIST'])
                .subscribe(translate => {
                    // this.notificationsService.alert(translate['NBS.PIB.EXIST']);
                    this.toastrService.info(translate['NBS.PIB.EXIST']);
                    return;
                });
            }
            else{
                this.loadingCompanyDataByPib = true;
                this.companyDataService.GetCompanyDataByTaxNo(this.baseFormGroup.get('Pib').value)
                .subscribe((data: CompanyData[]) => {
                    // this.loadingCompanyDataByPib = false;
                    if(data.length == 0){
                        this.translateService.get(['NBS.PIB.WARNING'])
                          .subscribe(translate => {
                            this.loadingCompanyDataByPib = false;
                            // this.notificationsService.alert(translate['NBS.PIB.WARNING']);
                            this.toastrService.info(translate['NBS.PIB.WARNING']);
                            return;
                          });
                    }
                    else{
                        //ovde treba poziv modalne forme sa onim što smo dobili od podataka.
                        this.kjsDataService.GetByPib(data[0].TaxIdentificationNumber)
                        .subscribe((kjsData: KJSData[]) => {
                            this.loadingCompanyDataByPib = false;
                            this.podesavanjeUvozNBS(data, "Pib", kjsData != null ? kjsData[0].Jbbk : "");  
                        });               
                    }
                })
            }
        });
        
        
    }
}

GetCompanyDataByMatBr(){
  if(!this.baseFormGroup.get('MaticniBroj').value || this.baseFormGroup.get('MaticniBroj').value == '' || this.fc.MaticniBroj.invalid){
      this.checkMaticniBroj = true;
      this.translateService.get(['NBS.MATICNIBROJ.WARNING'])
            .subscribe(translate => {
                // this.notificationsService.alert(translate['NBS.MATICNIBROJ.WARNING']);
                this.toastrService.info(translate['NBS.MATICNIBROJ.WARNING']);
                return;
            });
  }  
  else{  
    this.loadingCompanyData = true;
    this.companyDataService.GetCompanyDataByNationalIdentificationNo(this.baseFormGroup.get('MaticniBroj').value)
      .subscribe((data: CompanyData[]) => {
          this.loadingCompanyData = false;
          if(data.length == 0){
            this.translateService.get(['NBS.MATICNIBROJ.WARNING'])
            .subscribe(translate => {
            //   this.notificationsService.alert(translate['NBS.MATICNIBROJ.WARNING']);
              this.toastrService.info(translate['NBS.MATICNIBROJ.WARNING']);
              return;
            });
            //   alert('Ne postoje podaci za uneti MATIČNI BROJ');
            //   return;
          }
          else
            this.setCompanyData(data[0]);
      })    
    }
}

GetCompanyDataByMatBrNovo(value){
    if(!this.baseFormGroup.get('MaticniBroj').value || this.baseFormGroup.get('MaticniBroj').value == '' || this.fc.MaticniBroj.invalid){
        this.checkMaticniBroj = true;
        this.translateService.get(['NBS.MATICNIBROJ.WARNING'])
              .subscribe(translate => {
                //   this.notificationsService.alert(translate['NBS.MATICNIBROJ.WARNING']);
                  this.toastrService.info(translate['NBS.MATICNIBROJ.WARNING']);
                  return;
              });
    }  
    else{  
        this.baseDataService.Get("komitent","getIDfromUslov",[new QueryParameter('uslov', "maticni_broj = '" + this.baseFormGroup.get('MaticniBroj').value + "'")],Komitent)
        .subscribe((result) =>{
            if (Number(result) > 0){
                this.translateService.get(['NBS.MATICNIBROJ.EXIST'])
                .subscribe(translate => {
                    // this.notificationsService.alert(translate['NBS.MATICNIBROJ.EXIST']);
                    this.toastrService.info(translate['NBS.MATICNIBROJ.EXIST']);
                    return;
                });
            }
            else{
                this.loadingCompanyDataByMB = true;
                let mb: string;
                this.companyDataService.GetCompanyDataByNationalIdentificationNo(Number(this.baseFormGroup.get('MaticniBroj').value).toString())
                .subscribe((data: CompanyData[]) => {
                    // this.loadingCompanyDataByMB = false;
                    if(data.length == 0){
                        this.translateService.get(['NBS.MATICNIBROJ.WARNING'])
                          .subscribe(translate => {
                            this.loadingCompanyDataByMB = false;
                            // this.notificationsService.alert(translate['NBS.MATICNIBROJ.WARNING']);
                            this.toastrService.info(translate['NBS.MATICNIBROJ.WARNING']);
                            return;
                          });
                    }
                    else{
                        
                        //ovde treba poziv modalne forme sa onim što smo dobili od podataka.
                        this.kjsDataService.GetByMb(this.baseFormGroup.get('MaticniBroj').value)
                        .subscribe((kjsData: KJSData[]) => {
                            this.loadingCompanyDataByMB = false;
                            this.podesavanjeUvozNBS(data, "MB", kjsData != null ? kjsData[0].Jbbk : "");  
                        });              
                    }
                })
            }
        });
  
      }
  }

setCompanyData(data:CompanyData) {
  this.baseFormGroup.patchValue({Naziv: data.Name
                                , SNaziv: data.ShortName
                                , MaticniBroj: data.NationalIdentificationNumber
                                , Adresa: data.Address
                                , Web: data.Web
                                , Pib: data.TaxIdentificationNumber
                                , MestoID: data["CityID"] })
}

setCompanyDataNovo(data:CompanyData, ID: number, jbkjs: string) {
    let komitentUvozNbs : KomitentUvozNBS = new KomitentUvozNBS();
    let komitentUvozNbsObj : KomitentUvozNBS[]= [];
    let komitentEmail : KomitentEmail = new KomitentEmail();
    let komitentEmailObj : KomitentEmail[] = [];
    // let komitentZrc : KomitentZrc = new KomitentZrc();
    let komitentZrcObj : KomitentZrc[] = [];
    // let komitentTelefon : KomitentTelefon = new KomitentTelefon();
    let komitentTelefonObj : KomitentTelefon[] = [];

    komitentUvozNbs.ID = ID;
    komitentUvozNbs.Naziv = data.Name;
    komitentUvozNbs.SNaziv = data.ShortName;
    komitentUvozNbs.MaticniBroj = data.NationalIdentificationNumber;
    komitentUvozNbs.Pib = data.TaxIdentificationNumber;
    komitentUvozNbs.Adresa = data.Address;
    komitentUvozNbs.MestoID = data["CityID"];
    komitentUvozNbs.Jbkjs = jbkjs;

    if (data.Email != "" && data.Email != null){
        komitentEmail.Naziv = data.Email;
        komitentEmail.Glavni = true;
        komitentEmail.KomitentID = ID;
        komitentEmailObj.push(komitentEmail);
        komitentUvozNbs.Emaili = komitentEmailObj;
       
    }

    if (data.Phone != "" && data.Phone != null){
        let komitentTelefon : KomitentTelefon = new KomitentTelefon();
        komitentTelefon.Broj = data.Phone;
        komitentTelefon.Glavni = true;
        komitentTelefon.KomitentID = ID;
        komitentTelefonObj.push(komitentTelefon);
        komitentUvozNbs.Telefoni = komitentTelefonObj;
        
    }

    if (data.Phone2 != "" && data.Phone2 != null){
        let komitentTelefon : KomitentTelefon = new KomitentTelefon();
        komitentTelefon.Broj = data.Phone2;
        komitentTelefon.KomitentID = ID;
        komitentTelefonObj.push(komitentTelefon);
        komitentUvozNbs.Telefoni = komitentTelefonObj;
       
    }

    let index = 0; 
    data.AccountNumbers.forEach(zrc => {
        let komitentZrc : KomitentZrc = new KomitentZrc();
        zrc = zrc.replace(/-/g,"");
        komitentZrc.Zrc1=zrc.substr(0,3).trim();
        komitentZrc.Zrc2=zrc.substr(3,zrc.length-5).trim();
        komitentZrc.Zrc3=zrc.substr(zrc.length-2,2).trim();
        komitentZrc.Zrc=komitentZrc.Zrc1 +'-'+ komitentZrc.Zrc2 +'-'+ komitentZrc.Zrc3;
        // komitentZrc.Zrc = zrc;
        this.baseDataService.Get("banka","getIDfromUslov",[new QueryParameter('uslov', "sifra = '"+zrc.substr(0,3)+"'")],Banka)
        .subscribe((result) =>{
            if (result)
                komitentZrc.BankaID = Number(result);
        })
        if(index == 0)
            komitentZrc.Glavni = true;
        index ++;
        komitentZrc.KomitentID = ID;
        komitentZrcObj.push(komitentZrc);
        komitentUvozNbs.ZiroRacuni = komitentZrcObj;
    });

    komitentUvozNbsObj.push(komitentUvozNbs);
    this.komitentUvozNbs = komitentUvozNbsObj;
    return this.komitentUvozNbs;
  }


podesavanjeUvozNBS(data : CompanyData[], vrsta : string, jbkjs: string){
    if (vrsta == "MB")
        this.loadingCompanyDataByMB = true;
    else
        this.loadingCompanyDataByPib = true;

    let emailNazivConfig = {
        formControlName: 'Email',
        label: 'KOMITENTEMAIL.NAZIV.SINGULAR'
    }

    let glavniEmailConfig = {
        formControlName: 'Glavni',
        label: 'KOMITENTEMAIL.GLAVNI.SINGULAR'
    }

    let svojinaEmailConfig = {
        modelName: 'svojina',
        getName: 'get',
        modelProperty: 'Naziv',
        orderBy: 'Naziv',
        formControlName: 'SvojinaID',
        label: 'KOMITENTEMAIL.SVOJINA.SINGULAR',
        allowAddNew: false,
        width: 'xl',
        position: 'left'
    }
    
    let emailOpisConfig = {
        formControlName: 'Opis',
        label: 'KOMITENTEMAIL.OPIS.SINGULAR'
    }

    let vrstaTelefonaConfig = {
        modelName: 'vrstatelefona',
        getName: 'get',
        modelProperty: 'Naziv',
        orderBy: 'Naziv',
        formControlName: 'VrstaTelefonaID',
        label: 'KOMITENTTELEFON.VRSTATELEFONA.SINGULAR',
        allowAddNew: false,
        width: 'xl',
        position: 'left'
    }

    let brojTelefonaConfig = {
        formControlName: 'Broj',
        label: 'KOMITENTTELEFON.BROJ.SINGULAR'
    }

    let lokalTelefonaConfig = {
        formControlName: 'Lokal',
        label: 'KOMITENTTELEFON.LOKAL.SINGULAR'
    }

    let glavniTelefonConfig = {
        formControlName: 'Glavni',
        label: 'KOMITENTTELEFON.GLAVNI.SINGULAR'
    }

    let svojinaTelefonConfig = {
        modelName: 'svojina',
        getName: 'get',
        modelProperty: 'Naziv',
        orderBy: 'Naziv',
        formControlName: 'SvojinaID',
        label: 'KOMITENTTELEFON.SVOJINA.SINGULAR',
        allowAddNew: false,
        width: 'xl',
        position: 'left'
    }

    let opisTelefonaConfig = {
        formControlName: 'Opis',
        label: 'KOMITENTTELEFON.OPIS.SINGULAR'
    }

    let zrcConfig = {
        formControlName: 'Zrc',
        label: 'KOMITENTZRC.ZRC.SINGULAR'                   
    }

    let glavniZrcConfig = {
        formControlName: 'Glavni',
        label: 'KOMITENTZRC.GLAVNI.SINGULAR'
    }

    let bankaTelefonConfig = {
        modelName: 'banka',
        getName: 'get',
        modelProperty: 'Naziv',
        orderBy: 'Naziv',
        formControlName: 'BankaID',
        label: 'KOMITENTZRC.BANKA.SINGULAR',
        allowAddNew: false,
        width: 'xl',
        position: 'left'
    }

    let emailgridConfig = [
        {name: 'Email', label: 'KOMITENTEMAIL.NAZIV.SINGULAR', type: 'input', config: emailNazivConfig, disabled: false, required : 'true', width:'30%'}
        ,{name: 'Glavni', label: 'KOMITENTEMAIL.GLAVNI.SINGULAR', type: 'checkbox', config: glavniEmailConfig, disabled: true, width:'10%'}
        ,{name: 'SvojinaID', label: 'KOMITENTEMAIL.SVOJINA.SINGULAR', type: 'DDL', config: svojinaEmailConfig, disabled: false, required : 'true', width:'30%'}
        ,{name: 'Opis', label: 'KOMITENTEMAIL.OPIS.SINGULAR', type: 'input', config: emailOpisConfig, disabled: false, width:'30%'}
    ];

    let telefongridConfig = [
        {name: 'VrstaTelefonaID', label: 'KOMITENTTELEFON.VRSTATELEFONA.SINGULAR', type: 'DDL', config: vrstaTelefonaConfig, disabled: false, required : 'true', width:'15%'}
        ,{name: 'Broj', label: 'KOMITENTTELEFON.BROJ.SINGULAR', type: 'input', config: brojTelefonaConfig, disabled: true, required : 'true', width:'30%'}
        ,{name: 'Lokal', label: 'KOMITENTTELEFON.LOKAL.SINGULAR', type: 'input', config: lokalTelefonaConfig, disabled: true, width:'5%'}
        ,{name: 'Glavni', label: 'KOMITENTTELEFON.GLAVNI.SINGULAR', type: 'checkbox', config: glavniTelefonConfig, disabled: true, width:'10%'}
        ,{name: 'SvojinaID', label: 'KOMITENTTELEFON.SVOJINA.SINGULAR', type: 'DDL', config: svojinaTelefonConfig, disabled: false, required : 'true', width:'15%'}
        ,{name: 'Opis', label: 'KOMITENTTELEFON.OPIS.SINGULAR', type: 'input', config: opisTelefonaConfig, disabled: true, width:'25%'}
    ];
    
    let ziroracungridConfig = [
        {name: 'Zrc', label: 'KOMITENTZRC.ZRC.SINGULAR', type: 'ZRC', config: zrcConfig, disabled: 'true', required : 'true', width:'50%'}
        ,{name: 'Glavni', label: 'KOMITENTZRC.GLAVNI.SINGULAR', type: 'checkbox', config: glavniZrcConfig, disabled: true, width:'10%'}
        ,{name: 'BankaID', label: 'KOMITENTZRC.BANKA.SINGULAR', type: 'DDL', config: bankaTelefonConfig, disabled: false, required : 'true', width:'40%'}
    ];

    let emailgridParameter = new QueryParameter("emailgrid",emailgridConfig);
    let telefongridParameter = new QueryParameter("telefongrid",telefongridConfig);
    let ziroracungridParameter = new QueryParameter("ziroracungrid",ziroracungridConfig);

    // var komitentUvozNbs : List<KomitentUvozNBS>;
    this.setCompanyDataNovo(data[0], this.Item.ID, jbkjs);
    let komitentUvozNbsParameter = new QueryParameter("komitentUvozNbs",this.komitentUvozNbs);
    // this.komitentUvozNbs[0].ID = this.Item.ID;

    let modelData = new ModelData(null);
    modelData.ModalSize = ModalSize.Xl;
    modelData.UpdateComponent = KomitentUvozNbsComponent;

    if (vrsta == "MB")
        this.loadingCompanyDataByMB = false;
    else
        this.loadingCompanyDataByPib = false;

    this.modalService.ShowModal(this.Item.ID, modelData, null, true, [komitentUvozNbsParameter, emailgridParameter, telefongridParameter, ziroracungridParameter])
        .result
        .then((result) => {
            if (result && result>0)
            {
                this.baseDataService.GetByID("komitent", result, Komitent)
                    .subscribe((data: Komitent) =>{                                    
                        this.Item = data;
                        this.baseFormGroup.setValue(this.Item);
                        this.SavedItem = this.Item;  
                        this.SaveItem();                                    
                    })
            }
            else
                this.translateService.get(['NBS.CANCEL'])
                    .subscribe(translate => {
                        // this.notificationsService.alert(translate['NBS.CANCEL']);
                        this.toastrService.info(translate['NBS.CANCEL']);
                        return;
                    });
        })
}  
onTipKomitentaSelect(value:TipKomitenta){
   

    setTimeout(() => {
    if (value==null ){
        this.baseFormGroup.get('Pib').disable();
        this.baseFormGroup.get('Pib').updateValueAndValidity();
        this.baseFormGroup.get('MaticniBroj').disable();
        this.baseFormGroup.get('MaticniBroj').updateValueAndValidity();
        this.baseFormGroup.get('Jbkjs').disable();
        this.baseFormGroup.get('Jbkjs').updateValueAndValidity();
        this.baseFormGroup.get('Jmbg').disable();
        this.baseFormGroup.get('Jmbg').updateValueAndValidity();
        this.baseFormGroup.get('BrojGazdinstva').disable();
        this.baseFormGroup.get('BrojGazdinstva').updateValueAndValidity();
        this.baseFormGroup.get('ImeOca').disable();
        this.baseFormGroup.get('ImeOca').updateValueAndValidity();
        this.baseFormGroup.get('BrojLicneKarte').disable();
        this.baseFormGroup.get('BrojLicneKarte').updateValueAndValidity();
    }
    if (value!=null && value.GenericName=="PD"){
        this.baseFormGroup.get('Pib').enable();
        this.baseFormGroup.get('Pib').updateValueAndValidity();
        this.baseFormGroup.get('MaticniBroj').enable();
        this.baseFormGroup.get('MaticniBroj').updateValueAndValidity();
        this.baseFormGroup.get('Jbkjs').enable();
        this.baseFormGroup.get('Jbkjs').updateValueAndValidity();
        this.baseFormGroup.patchValue({Jmbg: null, BrojGazdinstva: null, ImeOca: null, BrojLicneKarte: null});
        this.baseFormGroup.get('Jmbg').disable();
        this.baseFormGroup.get('Jmbg').updateValueAndValidity();
        this.baseFormGroup.get('BrojGazdinstva').disable();
        this.baseFormGroup.get('BrojGazdinstva').updateValueAndValidity();
        this.baseFormGroup.get('ImeOca').disable();
        this.baseFormGroup.get('ImeOca').updateValueAndValidity();
        this.baseFormGroup.get('BrojLicneKarte').disable();
        this.baseFormGroup.get('BrojLicneKarte').updateValueAndValidity();
    }

    if (value!=null && value.GenericName=="PG"){
        this.baseFormGroup.patchValue({Pib: null, MaticniBroj: null, Jbkjs: null});
        this.baseFormGroup.get('Pib').disable();
        this.baseFormGroup.get('Pib').updateValueAndValidity();
        this.baseFormGroup.get('MaticniBroj').disable();
        this.baseFormGroup.get('MaticniBroj').updateValueAndValidity();
        this.baseFormGroup.get('Jbkjs').disable();
        this.baseFormGroup.get('Jbkjs').updateValueAndValidity();
        this.baseFormGroup.get('Jmbg').enable();
        this.baseFormGroup.get('Jmbg').updateValueAndValidity();
        this.baseFormGroup.get('BrojGazdinstva').enable();
        this.baseFormGroup.get('BrojGazdinstva').updateValueAndValidity();
        this.baseFormGroup.get('ImeOca').enable();
        this.baseFormGroup.get('ImeOca').updateValueAndValidity();
        this.baseFormGroup.get('BrojLicneKarte').enable();
        this.baseFormGroup.get('BrojLicneKarte').updateValueAndValidity();
    }

    if (value!=null && value.GenericName=="Ostalo"){
        this.baseFormGroup.get('Pib').enable();
        this.baseFormGroup.get('Pib').updateValueAndValidity();
        this.baseFormGroup.get('MaticniBroj').enable();
        this.baseFormGroup.get('MaticniBroj').updateValueAndValidity();
        this.baseFormGroup.get('Jbkjs').enable();
        this.baseFormGroup.get('Jbkjs').updateValueAndValidity();
        this.baseFormGroup.get('Jmbg').enable();
        this.baseFormGroup.get('Jmbg').updateValueAndValidity();
        this.baseFormGroup.get('BrojGazdinstva').enable();
        this.baseFormGroup.get('BrojGazdinstva').updateValueAndValidity();
        this.baseFormGroup.get('ImeOca').enable();
        this.baseFormGroup.get('ImeOca').updateValueAndValidity();
        this.baseFormGroup.get('BrojLicneKarte').enable();
        this.baseFormGroup.get('BrojLicneKarte').updateValueAndValidity();
    }
    // this.baseFormGroup.clearValidators();
    this.baseFormGroup.setValidators(CheckByTipKomitenta('TipKomitentaID','Pib','MaticniBroj','Jmbg','BrojGazdinstva'));
    this.baseFormGroup.updateValueAndValidity();
  
    this.changeDetectorRef.detectChanges();
    // this.changeDetectorRef.markForCheck();

    }, 100)
   

   
}

onMestoSelected(value:Mesto){
    this.mestoNaziv = value.Naziv;
}

onDrzavaSelected(value:Drzava){
    if (value){
        this.drzavaID = value.ID;
        this.drzavaNaziv = value.Naziv;
        this.idKomitenta = this.Item.ID;
        // provera drzavaID od firme, ako je ista, da vrati da je inoDrzava true
        this.baseDataService.Get('firma','GetCompanyId',null,Company)
            .subscribe((data:Company[])=>{
                this.inoDrzava = false;            
                if (data["DrzavaID"] != this.drzavaID){
                    this.inoDrzava = true;
                    this.baseFormGroup.patchValue({MestoID: 1163});
                    this.baseFormGroup.get('MestoID').updateValueAndValidity();
                }
                else{
                    this.baseFormGroup.patchValue({InoOpis : null, InoZip: null, InoMesto: null,InoPib: null});
                    this.baseFormGroup.get('InoOpis').updateValueAndValidity();
                    this.baseFormGroup.get('InoZip').updateValueAndValidity();
                    this.baseFormGroup.get('InoMesto').updateValueAndValidity();
                    this.baseFormGroup.get('InoPib').updateValueAndValidity();
                    // if (this.idKomitenta == -1){
                    //     this.baseFormGroup.patchValue({MestoID: null});
                    //     this.baseFormGroup.get('MestoID').updateValueAndValidity();
                    // }
                }
            
            this.baseFormGroup.get('InoZip').clearValidators();
            this.baseFormGroup.get('InoZip').updateValueAndValidity();
            this.addValidatorToFc("InoZip", CheckInoZipByDrzavaID('InoZip',this),'required','KOMITENT.ZIP.VALIDATION.REQUIRED');
            this.baseFormGroup.get('InoZip').updateValueAndValidity();

            this.baseFormGroup.get('InoMesto').clearValidators();
            this.baseFormGroup.get('InoMesto').updateValueAndValidity();
            this.addValidatorToFc("InoMesto", CheckInoMestoByDrzavaID('InoMesto',this),'required','KOMITENT.MESTO.VALIDATION.REQUIRED')
            this.baseFormGroup.get('InoMesto').updateValueAndValidity();
        })
    }

}

}

function CheckByTipKomitenta(tipKomitentaIDKey:string, pibKey: string, maticniBrojKey: string, jmbgKey: string, brojGazdinstvaKey: string){
   return (group: FormGroup): {[key : string]: any} =>{
    let tipKomitenaID = group.controls[tipKomitentaIDKey].value;
    let pib = group.controls[pibKey].value;
    let maticniBroj = group.controls[maticniBrojKey].value;
    let jmbg = group.controls[jmbgKey].value;
    let brojGazdinstva = group.controls[brojGazdinstvaKey].value;

    if (tipKomitenaID==null && pib==null && maticniBroj==null)
        return null;
    else{
        if (tipKomitenaID==1 && (pib=="" || maticniBroj=="" || pib==null || maticniBroj==null))
            return { checkControls :{valid:false, message: 'KOMITENT.TIPKOMITENTA.PRIVREDNODRUSTVO.VALIDATION'}};
        if (tipKomitenaID==2 && (jmbg=="" || brojGazdinstva=="" || jmbg==null || brojGazdinstva ==null))
            return { checkControls :{valid:false, message: 'KOMITENT.TIPKOMITENTA.GAZDINSTVO.VALIDATION'}};
        }  
    }    
}


function CheckInoMestoByDrzavaID(mestoKey: string, mainThis: any){
    return(group: FormGroup) : {[key: string]: any} => {
        let _mesto = group.parent.get(mestoKey) as FormControl;
        let mesto : string = _mesto.value;        
     
        if (mainThis.inoDrzava){
           
                if (mesto == "" || mesto == null || mesto == undefined)
                    return {
                        required: true
                    };
                else
                    return null;                    
        }
        else
            return null;
    }
}

function CheckInoZipByDrzavaID(zipKey: string, mainThis: any){
    return(group: FormGroup) : {[key: string]: any} => {
        let _zip = group.parent.get(zipKey) as FormControl;
        let zip : string = _zip.value;        
     
        if (mainThis.inoDrzava){
           
                if (zip == "" || zip == null || zip == undefined)
                    return {
                        required: true
                    }
                else
                    return null;                    
        }
        else
            return null;;
    }
}

